module.exports = {
  REQUIRED_FIELD: 'Campo requerido',
  EMAIL: 'E-mail inválido',
  PHONE: 'Le faltan digitos al número de teléfono ingresado'
};
